/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface Namespace { 
    /**
     * The Namespace code
     */
    namespaceCode: string;
    /**
     * An optional charge code that is associated with the Namespace
     */
    chargeCode?: string;
    /**
     * The S3 key prefix for the Namespace. This value is automatically generated by the system from the Namespace code. Note that the                   S3 key prefix will not contain a trailing \"directory\" separator and it will be up to the caller to append one as needed                
     */
    s3KeyPrefix?: string;
    /**
     * The default record flag for the namespace, this value will be used as the default record flag for the initial business object                   format created under this namespace.                
     */
    defaultRecordFlag?: boolean;
    /**
     * The default record code for the namespace when the defaultRecordFlag is set to true, this value will be used as the default                   record code for the initial business object format created under this namespace.                
     */
    defaultRecordCode?: string;
}
